import { StyleSheet } from 'react-native-web';
import { couleurBordurePrincipal } from '../../../../libs/utils';

export default StyleSheet.create({
  conteneur: {
    borderColor: couleurBordurePrincipal,
    borderBottomWidth: 0.25
  }
});
